export class OdooJsonRequest {
  jsonrpc = `2.0`;
  method = '';

  constructor(
    public params: any,
  ) {
  }
}


